import React from "react"

const Label = ({ children }) => {
    return (
        <p className="font-semibold text-pgray mb-1"> {children} </p>
    )
}

export default Label;